import { MENU_ITEM_ID } from '../constants/itemId'

export const runAction = (id: string) => {
  const { $didomiService } = useNuxtApp()
  switch (id) {
    case MENU_ITEM_ID.COOKIES:
      $didomiService.showPreferences()
      break
  }
}
